import { render, staticRenderFns } from "./DriverPropertiesForm.vue?vue&type=template&id=24ba061a&"
import script from "./DriverPropertiesForm.vue?vue&type=script&lang=js&"
export * from "./DriverPropertiesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24ba061a')) {
      api.createRecord('24ba061a', component.options)
    } else {
      api.reload('24ba061a', component.options)
    }
    module.hot.accept("./DriverPropertiesForm.vue?vue&type=template&id=24ba061a&", function () {
      api.rerender('24ba061a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Drivers/Forms/DriverPropertiesForm.vue"
export default component.exports